import React from 'react';
import PropTypes from 'prop-types';
import './headShot.css'

// const Person = ({ resumeItems }) => (
//   <div className='container'>
//     { resumeItems.map( item => {
//         return (
//           <div className='section has-text-justified'>
//             <h3 className='title is-2'>{item.prenominal} {item.name}<br/>
//               <span className='subtitle'>
//                 {item.title} - {item.postnominal}
//               </span>
//             </h3>
//             <div className='columns'>
//               <div className='column is-narrow'>
//                 <img alt='' src={item.image} alt={item.name} className='headShot'/>
//               </div>
//               <div className='column resumeData'>
//                 <p>
//                 {item.resume}
//                 </p>
//                 <p>Phone: <a href={"tel:" + item.landline}>{item.landline}</a></p>
//                 <p>Email: <a href={"mailto: " + item.email}>{item.email}</a></p>
//               </div>
//             </div>
//           </div>
//         );
//       })
//     }
//   </div>
// );

// Temporary simple block while working on content from Damian:
const Person = ({ resumeItems }) => (
  <div className='container'>
    { resumeItems.map( item => {
        return (
          <div className='section has-text-justified'>
            <h3 className='title is-2'>{item.prenominal} {item.name}
            </h3>
            {/* <div className='columns'>
              <div className='column is-narrow'>
                <img alt='' src={item.image} alt={item.name} className='headShot'/>
              </div>
              <div className='column resumeData'>
                <p>
                {item.resume}
                </p>
                <p>Phone: <a href={"tel:" + item.landline}>{item.landline}</a></p>
                <p>Email: <a href={"mailto: " + item.email}>{item.email}</a></p>
              </div>
            </div> */}
          </div>
        );
      })
    }
  </div>
);

Person.propTypes = {
  resumeItems: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      name: PropTypes.string,
      title: PropTypes.string,
      prenominal: PropTypes.string,
      postnominal: PropTypes.string,
      resmue: PropTypes.string,
      landline: PropTypes.string,
      mobile: PropTypes.string,
      email: PropTypes.string,
    })
  ),
};

export default Person;



// WEBPACK FOOTER //
// ./src/components/Resume/index.js